import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { router } from './router'
import { initSentry } from './services/sentry'
import { initAnalytics } from './services/analytics'
import './index.css'

// Sentry — must run FIRST (before the router/app render) so route instrumentation and error
// capture are in place from the first paint. No-op without VITE_SENTRY_DSN (local dev).
initSentry()

// Google Analytics — prod build only; wires SPA page-view tracking to the router (no-op elsewhere).
initAnalytics(router)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

